export enum ContactInfoTabRoutesEnum {
  phone = 'profile/contact-info',
  email = 'profile/contact-info/email',
  address = 'profile/contact-info/address',
}

export const contactInfoTabRouteKeys = {
  [ContactInfoTabRoutesEnum.phone]: 0,
  [ContactInfoTabRoutesEnum.email]: 1,
  [ContactInfoTabRoutesEnum.address]: 2,
} as const;

/** Longer routes first so pathname matching resolves sub-routes correctly. */
export const contactInfoTabRoutes = [
  ContactInfoTabRoutesEnum.address,
  ContactInfoTabRoutesEnum.email,
  ContactInfoTabRoutesEnum.phone,
] as const;
